import axios from 'axios';

import {
  IBulkChartsPayload,
  IPostgreAnalyticsBulkPayload,
} from '../types/IComposableAnalyticsCharts';
import IComposableDashboard from '../types/IComposableDashboardContext';

const url = 'wsreporting/api/';

export const saveLayout = (query: IComposableDashboard) =>
  axios.post(`${url}your-dashboard/save-dashboard`, query);

export const fetchLayout = (query: IComposableDashboard) =>
  axios.post(`${url}your-dashboard/fetch-layout`, query);

export const updateDashboard = (query: IComposableDashboard) =>
  axios.post(`${url}your-dashboard/update-dashboard`, query);

export const fetchMyDashboards = () => axios.get(`${url}your-dashboard/fetch-my-dashboards`);

export const deleteDashboard = (dashboardId: string) =>
  axios.get(`${url}your-dashboard/delete-dashboard`, { params: { dashboardId } });

export const fetchDashboardsByIds = (query: string[]) =>
  axios.get(`${url}your-dashboard/fetch-dashboards-by-ids?ids=${query.map((id) => id).join(',')}`);

export const fetchBulkChartsResponse = (bulkQuery: IBulkChartsPayload[], signal: AbortSignal) =>
  axios.post(`${url}your-dashboard/fetch-bulk-charts-data`, bulkQuery, {
    signal,
  });

export const fetchPostgreBulkChartsResponse = (bulkQuery: IPostgreAnalyticsBulkPayload) =>
  axios.post(
    '/analyticsreportingapp/api/candidate-submission/composable-analytics/bulk-with-filters',
    bulkQuery
  );
